import React from "react";

import { Container, H1, Content,Strong } from "./styles";
import Title from "../../components/Title";

export default function Exchange() {
  return (
    <Container className="wl-page">
      <Title label={"Política de Trocas e Devoluções"} />
        <Content>
          A LL segue as políticas de trocas e devoluções dos Programas de Fidelidade e de nossas
          Marcas parceiras. Se quiser solicitar a devolução ou troca de produtos, entre em contato
          com a LL por algum de nossos canais de atendimento em até 7 dias corridos do
          recebimento do produto que iremos orientar como fazer a troca ou devolução.
          <br />
          O ressarcimento dos valores por arrependimento ou desistência serão feitos via estorno
          no mesmo cartão de crédito usado para efetuar o pagamento da compra. Lembrando que
          todas as operadoras de cartão de crédito podem demorar até duas faturas para realizar o
          crédito.
          <br />
          <b>Importante: para realizar a troca ou devolução, o produto precisa estar em sua embalagem
          original, com etiquetas e lacres intactos. Todos os acessórios devem ser enviados junto
          com o produto. O produto não pode ter sido usado ou estar danificado e a nota fiscal deve
        ser enviada juntamente com o produto.</b>
        </Content>
    </Container>
  );
}
